import React, { useEffect, useState } from "react";

import { Divider, Layout, Menu } from "antd";
import { NavLink, Outlet } from "react-router-dom";

import "./Library.css";
import { collection, getDocs, query, where } from "firebase/firestore";
import { auth, db } from "../../../firebase";
import { useAuthState } from "react-firebase-hooks/auth";
const { Content, Sider } = Layout;

function getItem(label, key, icon, children) {
  return {
    key,
    icon,
    children,
    label,
  };
}

const Library = () => {
  const [companyName, setCompanyName] = useState("");
  const [isCompanyNameFetched, setIsCompanyNameFetched] = useState(false);
  const [user, loading] = useAuthState(auth);

  const fetchCompanyName = async () => {
    try {
      const usersRef = collection(db, "allUsers");
      const userData = query(usersRef, where("uid", "==", user?.uid));
      const querySnapshot = await getDocs(userData);
      querySnapshot.forEach((doc) => {
        const res = doc.data();
        setCompanyName(res.companyName);
      });
      setIsCompanyNameFetched(true);
    } catch (error) {
      console.log("Error getting company name: ", error);
    }
  };
  useEffect(() => {
    fetchCompanyName();
  }, [user, loading]);

  const sidebBarNav = [
    getItem(
      <NavLink to="/tasks/library" end>
        <span style={{ textTransform: "uppercase" }}>{companyName}</span>
      </NavLink>,
      "library",
      <i className="fa-solid fa-hotel"></i>
    ),
    // getItem(
    //   <NavLink to="/tasks/library/privateLibrary">Private Library</NavLink>,
    //   "CalendarKey",
    //   <i className="fa-solid fa-user-lock"></i>
    // ),
    // getItem(
    //   <NavLink to="/tasks/library/library-scheduled">Scheduled</NavLink>,
    //   "scheduled",
    //   <i className="fa-regular fa-clock"></i>
    // ),
    // getItem(<Divider />, "divider"),
    // getItem(
    //   <NavLink to="/tasks/library/user-tag">User</NavLink>,
    //   "user-tag",
    //   <i className="fa-solid fa-tag"></i>
    // ),
  ];
  return (
    <div className="library">
      <Layout
        style={{
          background: "white",
          height: "calc( 100vh - 124px)",
        }}
      >
        <Sider
          style={{
            background: "white",
          }}
          width={300}
        >
          <Menu
            mode="inline"
            defaultSelectedKeys={["1"]}
            defaultOpenKeys={["sub1"]}
            style={{
              height: "100%",
              paddingTop: "14px",
            }}
            items={sidebBarNav}
          />
        </Sider>
        <Content
          style={{
            padding: "24px 24px 0 24px",
            minHeight: 280,
          }}
        >
          <Outlet />
        </Content>
      </Layout>
    </div>
  );
};

export default Library;
